"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tiny_emitter_1 = require("tiny-emitter");
const axios_1 = require("axios");
class Network {
    constructor(apiKey, user, baseUrl, pathUrl, timeout) {
        this.apiKey = apiKey;
        this.user = user;
        this.baseUrl = baseUrl;
        this.pathUrl = pathUrl;
        this.timeout = timeout;
        if (!apiKey)
            throw new Error('apiKey is required');
        this.apiKey = apiKey;
        this.baseUrl = baseUrl || 'https://sdk.koople.io';
        this.pathUrl = pathUrl || '/proxy/client/initialize';
        this.timeout = timeout && timeout > 0 ? timeout : 0;
        this.emitter = new tiny_emitter_1.TinyEmitter();
        this.httpClient = axios_1.default.create({ baseURL: this.baseUrl });
    }
    onSuccess(callback) {
        this.emitter.on('success', callback);
    }
    onUnauthorized(callback) {
        this.emitter.on('unauthorized', callback);
    }
    onError(callback) {
        this.emitter.on('error', callback);
    }
    initialize() {
        const params = { headers: { 'x-api-key': this.apiKey } };
        this.httpClient.post(this.pathUrl, this.user, params)
            .then(({ data: { evaluation } }) => {
            this.emitter.emit('success', evaluation);
        })
            .catch((error) => {
            if (error.response && error.response.status === 401) {
                this.emitter.emit('unauthorized', new Error('unauthorized'));
            }
            else {
                this.emitter.emit('error', error);
            }
        });
        if (this.timeout > 0) {
            setTimeout(() => {
                this.emitter.emit('error', new Error('timeout'));
            }, this.timeout);
        }
    }
}
exports.Network = Network;
//# sourceMappingURL=Network.js.map